export function decodeJwtPayload<T = any>(jwt?: string): T | null {
  if (!jwt) return null;
  try {
    const base = jwt.split(".")[1]; if (!base) return null;
    const json = atob(base.replace(/-/g, "+").replace(/_/g, "/"));
    return JSON.parse(json);
  } catch { return null; }
}

export function hasRole(token?: string, role = "ops"): boolean {
  const p = decodeJwtPayload<any>(token) || {};
  const roles = Array.isArray(p.roles) ? p.roles :
    typeof p.role === "string" ? [p.role] :
    typeof p.scope === "string" ? p.scope.split(/\s+/) : [];
  return roles.includes(role);
}

export const fmt = {
  num(n?: number) { return (n ?? 0).toLocaleString(); },
  ms(n?: number) { return n==null ? "—" : `${Math.round(n)} ms`; },
  s(n?: number)  { return n==null ? "—" : `${Math.round(n)} s`; },
  pct(n?: number){ return n==null ? "—" : `${(n*100).toFixed(2)}%`; }
};


